// app/router/AppRouter.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Страницы
import MainPage from '../../pages/MainPage/Main';
import CategoryChoicePage from '../../pages/CategoryChoicePage/CategoryChoice';
import CategoryItemsPage from '../../pages/CategoryItemsPage/CategoryItems';
import LocationPage from '../../pages/LocationPage/Location';
import RoutePage from '../../pages/RoutePage/Route';
import TagChoicePage from '../../pages/TagChoicePage/TagChoice';
import TagItemsPage from '../../pages/TagItemsPage/TagItems';

const AppRouter = () => {
  return (
    <>
      <main className="main-content">
        <Routes>
          
          <Route path='/' element={<MainPage />} />
          
          <Route path='/locations/:id' element={<LocationPage />} />
          <Route path='/routes/:id' element={<RoutePage />} />

          <Route path='/categories/type/:type' element={<CategoryChoicePage />} />
          <Route path='/categories/:id/:type' element={<CategoryItemsPage />} />

          <Route path='/tags' element={<TagChoicePage />} />
          <Route path='/tags/:id' element={<TagItemsPage />} />
          
        </Routes>
      </main>
    </>
  );
};

export default AppRouter;